import React from 'react'
import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useState as uState, useEffect as uEffect } from "react";


export default function productTable() {
    const [data, setData] = uState([]);

    uEffect(() => {
        fetch("http://localhost:8000/products/allProduct", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => setData(data));
    }, []);

    const handleDelete = (id) => {
        fetch("http://localhost:8000/products/deleteOne", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body:JSON.stringify({productId:id})
        })
        setData(data.filter((item) => item._id !== id))
    };

    function getRowId(data) {
        return data._id;
    }


    const productColumns = [
        { field: "_id", headerName: "ID", width: 100 },
        {
            field: "productTitle",
            headerName: "Title",
            width: 150,
            renderCell: (params) => {
                const { productTitle, productImage } = params.row;
                return (
                    <div className="cellWithImg">
                        {/* {imageUrl ? (
                            <img className='cellImg' src={`http://localhost:8000/public/${imageUrl}`} alt="" />
                        ) : (
                                <img className='cellImg' src={`${productImage}`} alt="" />
                        )} */}
                        <img className="cellImg" src={`http://localhost:8000/public/images/${productImage}`} alt="avatar" />
                        {productTitle}
                    </div>
                );
            },
        },
        { field: "productQuantity", headerName: "Quantity", width: 150 },
        { field: "productAmount", headerName: "Amount", width: 150 },
        {
            field: "productType",
            headerName: "Type",
            width: 250,
            renderCell: (params) => {
                const { productType } = params.row;
                return <div className={`cellWithStatus ${productType}`}>{productType}</div>;
            },
        },
    ];


    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 250,
            renderCell: (params) => {
                const { _id } = params.row;
                return (
                    <div className="cellAction">
                        <Link
                            to={`${_id}`}
                            style={{ textDecoration: "none" }}
                        >
                            <div className="viewButton">View</div>
                        </Link>
                        <Link
                            to={`/productUpdate/${_id}`}
                            style={{ textDecoration: "none" }}
                        >
                            <div className="viewButton">Update</div>
                        </Link>
                        <div className="deleteButton" onClick={() => handleDelete(_id)}>
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];
  return (
      <>
      
          <div className="datatable">
              <div className="datatableTitle">
                  Add New Product
                  <Link to="/adminProducts/newProduct" className="link">
                      Add New
                  </Link>
              </div>
              <DataGrid
                  className="datagrid"
                  getRowId={getRowId}
                  rows={data}
                  columns={productColumns.concat(actionColumn)}
                  pageSize={9}
                  rowsPerPageOptions={[9]}
                  checkboxSelection
              />
          </div>


      
      </>
  )
}
